import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-adapter',
  templateUrl: './icon-adapter.component.html',
  styleUrls: ['./icon-adapter.component.scss']
})
export class IconAdapterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
